import GamePage from "./pages/GamePage";
import HomePage from "./pages/Home";
import Guides from "./pages/Guides";
import {Route, Routes} from "react-router-dom";
import Schools from "./pages/Schools";
import Contact from "./pages/Contact";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/play" element={<GamePage />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/schools" element={<Schools />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;